exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lightbox-nav{position:relative;margin-bottom:12px;height:22px;text-align:center;font-size:0}.lightbox-nav .btn-group{vertical-align:top}.lightbox-nav .close{position:absolute;top:0;right:0}.lightbox-image-container{position:relative;text-align:center}.lightbox-image-caption{position:absolute;top:0;left:0;margin:.5em .9em;color:#000;font-size:1.5em;font-weight:700;text-align:left;text-shadow:.1em .1em .2em hsla(0,0%,100%,.5)}.lightbox-image-caption span{padding-top:.1em;padding-bottom:.1em;background-color:hsla(0,0%,100%,.75);box-shadow:.4em 0 0 hsla(0,0%,100%,.75),-.4em 0 0 hsla(0,0%,100%,.75)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.css
 ** module id = 44
 ** module chunks = 0
 **/